export function redactSecret(value: string | null | undefined, visibleChars = 4): string {
  if (!value) return ''
  const str = String(value)
  if (str.length <= visibleChars) return `***(${str.length})`
  return `***${str.slice(-visibleChars)}(${str.length})`
}
